module.exports = __webpack_public_path__ + "static/media/direction.d3dc567b.svg";